<template>
  <div style="text-align: center">
    <a-modal v-model="changeRemarkible" footer="'" title="备注信息" width="75%">
      <div v-if="loading" class="example">
        <a-spin />
      </div>
      <div v-if="loading == false">
        <a-row v-if="this.reslist && store.getters.userType != '22'">
          <a-col :span="2"></a-col>
          <a-col :span="20">
            <div class="table-page-search-wrapper" style="margin-bottom: 15px">
              <a-form layout="inline">
                <a-row :gutter="24" style="margin-left: 20px">
                  <a-col :span="4"> <a-date-picker disabled v-model="orderReminde.date"/></a-col>
                  <a-col :span="3">
                    <a-time-picker
                      :disabledHours="disabledDate"
                      :disabledMinutes="disabledMinutes"
                      :disabledSeconds="disabledSeconds"
                      format="HH:mm:ss"
                      :disabled="disabledTime"
                      @change="getTimeClick"
                      v-model="timeValueString"
                  /></a-col>
                  <a-col :span="8">
                    <a-input
                      :disabled="disabledTime"
                      v-model="orderReminde.remark"
                      :maxLength="20"
                      placeholder="提醒事项"
                  /></a-col>
                  <a-button type="primary" style="" :disabled="disabledTime" @click="handleStart()">启动 </a-button>
                </a-row>
                <a-table
                  size="default"
                  ref="table"
                  :columns="mastercolumns"
                  :dataSource="this.reslist.masterRemark"
                  :pagination="false"
                >
                  <span slot="action" slot-scope="text, record"
                    ><a @click="orderRemarkEdit(record)">编辑</a> <a-divider type="vertical" /><a-popconfirm
                      title="是否要删除此行？"
                      @confirm="removeorderRemark(record.orderRemarkId)"
                      ><a>删除</a></a-popconfirm
                    >
                    <!--<a-divider-->
                    <!--type="vertical"/>-->
                    <!--<a @click="handleEdit(record)">追加</a>-->
                  </span>
                </a-table>
              </a-form>
            </div>
            <a-row>
              <a-col :span="20">
                <a-row style="margin-left: -4.5px;margin-left: 20px;">
                  <!--<a-col :span="1" style="margin-top: 4px;margin-right: 15px;"></a-col>-->
                  <a-col :span="20">
                    <a-form-item
                      label="师傅备注"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      style="width: 100%;margin-left:-55px;"
                    >
                      <a-textarea v-model.trim="remark.remarkInfo" :rows="2" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="2" style="">
                    <a-button type="primary" style="" @click="Submission()">提交 </a-button>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <a-row v-if="this.reslist">
          <a-col :span="2"></a-col>
          <a-col :span="20">
            <div class="table-page-search-wrapper" style="margin-bottom: 15px">
              <a-form layout="inline" :form="form">
                <a-table
                  size="default"
                  ref="table"
                  :columns="ordercolumns"
                  :dataSource="this.reslist.orderRemark"
                  :form="form"
                  :scroll="{ x: 800 }"
                  :pagination="false"
                >
                  <span slot="action" slot-scope="text, record">
                    <span v-if="viewInnerRemark && !viewOuterrRemark">
                      <a v-if="editInnerRemark" @click="orderRemarkEdit(record)">编辑</a>
                      <a-divider type="vertical" />
                      <a-popconfirm title="是否要删除此行？" @confirm="removeorderRemark(record.orderRemarkId)">
                        <a v-if="addOrDeleteInnerRemark">删除</a>
                      </a-popconfirm>
                      <!--<a-divider type="vertical"/>-->
                      <!--<a v-if="addOrDeleteInnerRemark" @click="">追加</a>-->
                    </span>
                    <span v-if="!viewInnerRemark && viewOuterrRemark">
                      <a v-if="editOuterrRemark" @click="orderRemarkEdit(record)">编辑</a>
                      <a-divider type="vertical" />
                      <a-popconfirm title="是否要删除此行？" @confirm="removeorderRemark(record.orderRemarkId)">
                        <a v-if="addOrDeleteOuterRemark">删除</a>
                      </a-popconfirm>
                      <!--<a-divider type="vertical"/>-->
                      <!--<a v-if="addOrDeleteOuterRemark" @click="">追加</a>-->
                    </span>
                    <span v-if="viewInnerRemark && viewOuterrRemark">
                      <a v-if="record.remarkType == 1 && editOuterrRemark" @click="orderRemarkEdit(record)">编辑</a>
                      <a v-if="record.remarkType == 0 && editOuterrRemark" @click="orderRemarkEdit(record)">编辑</a>
                      <a-divider type="vertical" />
                      <a-popconfirm title="是否要删除此行？" @confirm="removeorderRemark(record.orderRemarkId)">
                        <a v-if="record.remarkType == 1 && addOrDeleteOuterRemark">删除</a>
                        <a v-if="record.remarkType == 0 && addOrDeleteOuterRemark">删除</a>
                      </a-popconfirm>
                      <!--<a-divider type="vertical"/>-->
                      <!--<a v-if="record.remarkType==1 && addOrDeleteOuterRemark" @click="">追加</a>-->
                      <!--<a v-if="record.remarkType==0 && addOrDeleteOuterRemark" @click="">追加</a>-->
                    </span>
                  </span>
                </a-table>
              </a-form>
            </div>
            <a-row>
              <a-col :span="20">
                <a-row style="margin-left: -4.5px;margin-left: 20px;">
                  <a-col :span="20">
                    <a-form-item
                      label="企业"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      style="width: 100%;margin-left:-55px;"
                    >
                      <a-textarea v-model.trim="orderremark.remark1" :rows="2" />
                    </a-form-item>
                    <a-form-item
                      label="客户"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      style="width: 100%;margin-left:-55px;"
                    >
                      <a-textarea v-model.trim="orderremark.remark2" :rows="2" />
                    </a-form-item>
                    <a-form-item
                      label="师傅"
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      style="width: 100%;margin-left:-55px;"
                    >
                      <a-textarea v-model.trim="orderremark.remark3" :rows="2" />
                    </a-form-item>
                  </a-col>
                  <a-col :span="2" style="display:flex;flex-wrap: wrap;">
                    <a-button v-if="addOuterrRemark" type="primary" style="margin-bottom: 20px;" @click="external"
                      >外部
                    </a-button>
                    <a-button type="primary" v-if="addInnerRemark" style="" @click="inside">内部</a-button>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="2"></a-col>
        </a-row>
      </div>
    </a-modal>
    <a-modal v-model="orderRemarkble" @ok="addremark()" title="修改备注">
      <a-form :form="form">
        <a-row>
          <a-col>
            <a-form-item style="display:none">
              <a-input v-model="orderRemarkmodal.orderRemarkId" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注内容">
              <a-input v-model.trim="orderRemarkmodal.remarkInfo" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getdeleteOrderRemark, getupdateOrderRemark, getaddOrderRemark } from '@/api/order/editorder'
import { getOrderDetail, queryRemind, addOrderRemindData } from '@/api/order/orderList'
import store from '@/store'
import moment from 'moment'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'ChangeRemarksModel',
  data() {
    return {
      store,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      loading: true,
      remark: {},
      orderremark: {},
      orderReminde: {
        remark: ''
      }, // 订单提醒
      ordercolumns: [
        {
          title: '',
          width: 150,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '',
          dataIndex: 'remarkType',
          width: 60,
          customRender: text => {
            if (text == 1) {
              return '外部'
            } else {
              return '内部'
            }
          }
        },
        {
          title: '',
          dataIndex: 'remarkInfo' /* customRender: (text) => text + ' 订单要求' */
        },
        {
          title: '',
          dataIndex: 'updateBy',
          width: 60
        },
        {
          title: '',
          dataIndex: 'updateTime',
          width: 160
        }
        // {title: '', dataIndex: 'createTime',width:120}
      ],
      disabledTime: false,
      timeValueString: null,
      timeString: null,
      mastercolumns: [
        {
          title: '',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' }
        },
        /* { title: '', dataIndex: 'remarkType', customRender: (text) => { if(text==1){return '外部'}else {return'内部'} } }, */ {
          title: '',
          dataIndex: 'remarkInfo'
          /* customRender: (text) => text + ' 订单要求' */
        },
        // {title: '', dataIndex: 'createTime',width:120},
        {
          title: '',
          dataIndex: 'updateBy',
          width: 60
        },
        {
          title: '',
          dataIndex: 'updateTime',
          width: 160
        }
      ],
      orderRemarkble: false,
      changeRemarkible: false,
      orderRemarkmodal: '',
      reslist: '',
      viewInnerRemark: checkPermission('viewInnerRemark'),
      addInnerRemark: checkPermission('addInnerRemark'),
      editInnerRemark: checkPermission('editInnerRemark'),
      addOrDeleteInnerRemark: checkPermission('addOrDeleteInnerRemark'),
      viewOuterrRemark: checkPermission('viewOuterrRemark'),
      addOuterrRemark: checkPermission('addOuterrRemark'),
      editOuterrRemark: checkPermission('editOuterrRemark'),
      addOrDeleteOuterRemark: checkPermission('addOrDeleteOuterRemark')
    }
  },
  created() {
    this.orderReminde.date = moment(moment().format('YYYY-MM-DD '))
  },
  methods: {
    // 外部
    external() {
      this.orderremark.orderId = this.reslist.orderId
      this.orderremark.remarkType = 1
      let str = ''
      if (this.orderremark.remark1) {
        str += '企业：' + this.orderremark.remark1 + '；'
      }
      if (this.orderremark.remark2) {
        str += '客户：' + this.orderremark.remark2 + '；'
      }
      if (this.orderremark.remark3) {
        str += '师傅：' + this.orderremark.remark3 + '；'
      }
      this.orderremark.remarkInfo = str
      if (this.orderremark.remarkInfo) {
        getaddOrderRemark(this.orderremark).then(res => {
          if (res.code === 0) {
            console.log(res)
            this.orderremark = {}
            getOrderDetail({ orderId: this.reslist.orderId }).then(res => {
              if (res.code === 0) {
                this.reslist.orderRemark = res.data.orderRemark
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    // 内部
    inside() {
      this.orderremark.orderId = this.reslist.orderId
      this.orderremark.remarkType = 0
      let str = ''
      if (this.orderremark.remark1) {
        str += '企业：' + this.orderremark.remark1 + '；'
      }
      if (this.orderremark.remark2) {
        str += '客户：' + this.orderremark.remark2 + '；'
      }
      if (this.orderremark.remark3) {
        str += '师傅：' + this.orderremark.remark3 + '；'
      }
      this.orderremark.remarkInfo = str
      if (this.orderremark.remarkInfo) {
        getaddOrderRemark(this.orderremark).then(res => {
          if (res.code === 0) {
            console.log(res)
            this.orderremark = {}
            getOrderDetail({ orderId: this.reslist.orderId }).then(res => {
              if (res.code === 0) {
                this.reslist.orderRemark = res.data.orderRemark
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    // 提交
    Submission() {
      this.remark.orderId = this.reslist.orderId
      this.remark.remarkType = 2
      if (this.remark.remarkInfo) {
        getaddOrderRemark(this.remark).then(res => {
          if (res.code === 0) {
            console.log(res)
            this.remark = {}
            getOrderDetail({ orderId: this.reslist.orderId }).then(res => {
              if (res.code === 0) {
                this.reslist.masterRemark = res.data.masterRemark
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请填写备注内容')
      }
    },
    disabledDate(current) {
      const hour = moment().hour()
      var hours = []
      for (var i = 0; i < hour; i++) {
        hours.push(i)
      }
      return hours
    },
    disabledMinutes(current) {
      const hour = moment().hour()
      if (current <= hour) {
        const minute = moment().minutes()
        var minutes = []
        for (var i = 0; i < minute; i++) {
          minutes.push(i)
        }
        return minutes
      }
    },
    disabledSeconds(current) {
      const hour = moment().hour()
      if (current <= hour) {
        const second = moment().seconds()
        var seconds = []
        for (var i = 0; i < second; i++) {
          seconds.push(i)
        }
        console.log(seconds)
        return seconds
      }
    },
    getTimeClick(data, datastring) {
      console.log(datastring)
      this.disabledMinutes()
      this.disabledSeconds()
      this.timeString = datastring
    },
    getMoreList() {
      queryRemind({
        orderId: this.reslist.orderId,
        remindType: 1,
        status: 0
      }).then(res => {
        this.$emit('ok3', 0)
        this.$emit('ok3', 1)
        if (res.data == null) {
          this.disabledTime = false
          this.orderReminde.remark = ''
          this.timeValueString = null
        } else {
          this.disabledTime = true
          this.moreOrderList = res.data
          this.orderReminde.remark = res.data.remark
          this.timeValueString = moment(res.data.timeQuantum, 'HH:mm:ss')
        }
      })
    },
    // 订单提醒启动
    // 启动提醒
    handleStart() {
      if (this.timeString == null || this.timeString == '') {
        this.$message.error('请选择提醒时间！')
      } else if (this.orderReminde.remark == '') {
        this.$message.error('请输入提醒内容！')
      } else {
        console.log(this.reslist)
        // var orderList = this.reslist
        // orderList.remindType = 1
        // orderList.remark = this.orderReminde.remark
        // orderList.appointmentTime = moment(new Date()).format('YYYY-MM-DD')
        // orderList.timeQuantum = this.timeString
        const orderRemind = {}
        orderRemind.installType = this.reslist.installType
        orderRemind.orderId = this.reslist.orderId
        orderRemind.orderNo = this.reslist.orderNo
        orderRemind.orderStatus = this.reslist.orderStatus
        orderRemind.orderType = this.reslist.orderType
        orderRemind.remindType = 1
        orderRemind.remark = this.orderReminde.remark
        orderRemind.appointmentTime = moment(new Date()).format('YYYY-MM-DD')
        orderRemind.timeQuantum = this.timeString
        addOrderRemindData(orderRemind).then(res => {
          if (res.code === 0) {
            this.$message.success('启动成功！')
            this.getMoreList()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    // 初始
    showChangeRemark(id) {
      this.changeRemarkible = true
      this.loading = true
      getOrderDetail({ orderId: id }).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.reslist = res.data
          this.getMoreList()
          if (this.reslist) {
            this.reslist.masterRemark = res.data.masterRemark
            // console.log(res.data.orderRemark)
            // console.log(this.viewInnerRemark ,this.viewOuterrRemark)
            if (this.viewInnerRemark && this.viewOuterrRemark) {
              this.reslist.orderRemark = res.data.orderRemark
            } else if (this.viewInnerRemark && !this.viewOuterrRemark) {
              this.reslist.orderRemark = res.data.orderRemark.filter(item => item.remarkType == 0)
              // console.log(111,this.reslist.orderRemark)
            } else if (!this.viewInnerRemark && this.viewOuterrRemark) {
              this.reslist.orderRemark = res.data.orderRemark.filter(item => item.remarkType == 1)
              // console.log(222,this.reslist.orderRemark)
            } else {
              this.reslist.orderRemark = []
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 刷新
    addremark() {
      this.orderRemarkble = false
      getupdateOrderRemark(this.orderRemarkmodal).then(res => {
        if (res.code === 0) {
          getOrderDetail({ orderId: this.reslist.orderId }).then(res => {
            if (res.code === 0) {
              this.reslist.orderRemark = res.data.orderRemark
              this.reslist.masterRemark = res.data.masterRemark
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    orderRemarkEdit(record) {
      this.orderRemarkble = true
      this.orderRemarkmodal = record
    },
    // 删除
    removeorderRemark(id) {
      console.log(id)
      getdeleteOrderRemark({ orderRemarkId: id }).then(res => {
        if (res.code === 0) {
          console.log(res)
          getOrderDetail({ orderId: this.reslist.orderId }).then(res => {
            if (res.code === 0) {
              this.reslist.orderRemark = res.data.orderRemark
              this.reslist.masterRemark = res.data.masterRemark
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
.example {
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
/*/deep/ .ant-table td { white-space: nowrap; padding: 6px 16px;}*/
</style>
